import { render, staticRenderFns } from "./KitMetricCardHeader.vue?vue&type=template&id=b044a1fa"
import script from "./KitMetricCardHeader.vue?vue&type=script&lang=ts"
export * from "./KitMetricCardHeader.vue?vue&type=script&lang=ts"
import style0 from "./KitMetricCardHeader.vue?vue&type=style&index=0&id=b044a1fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports